module.exports = __webpack_public_path__ + "img/clientes.2ea5eac5.png";